var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookmarkOutlined = function SvgBookmarkOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    fillRule: "evenodd",
    d: "M6.5 5.5v13.18l4.326-2.95a2.08 2.08 0 0 1 2.348 0l4.326 2.95V5.5zM5.583 4A.584.584 0 0 0 5 4.584v15.831c0 .47.525.747.912.483l5.76-3.93a.58.58 0 0 1 .656 0l5.76 3.93a.583.583 0 0 0 .912-.483V4.584A.584.584 0 0 0 18.417 4z",
    clipRule: "evenodd"
  })));
};
export default SvgBookmarkOutlined;